import { storableError } from '../../util/errors';
import { submitScreenShareDisclosureEvent } from '../../util/api';

// ================ Action types ================ //

export const DISCLOSURE_EVENT_REQUEST = 'app/AIInterviewScreenShareGatePage/DISCLOSURE_EVENT_REQUEST';
export const DISCLOSURE_EVENT_SUCCESS = 'app/AIInterviewScreenShareGatePage/DISCLOSURE_EVENT_SUCCESS';
export const DISCLOSURE_EVENT_ERROR = 'app/AIInterviewScreenShareGatePage/DISCLOSURE_EVENT_ERROR';

// ================ Reducer ================ //

const initialState = {
  inProgress: false,
  error: null,
  screenShareDisclosureState: null,
  // The start gate ends an attempt, it never pauses one — there is nothing to resume from.
  ended: false,
};

export default function aiInterviewScreenShareGatePageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case DISCLOSURE_EVENT_REQUEST:
      return { ...state, inProgress: true, error: null };
    case DISCLOSURE_EVENT_SUCCESS:
      return {
        ...state,
        inProgress: false,
        screenShareDisclosureState: payload.screenShareDisclosureState || null,
        ended: !!payload.ended,
      };
    case DISCLOSURE_EVENT_ERROR:
      return { ...state, inProgress: false, error: payload };
    default:
      return state;
  }
}

// ================ Thunks ================ //

// The server owns the disclosure state machine; the client only reports which UI event occurred
// (shown | declined | go_back | confirmed | dismissed_inconclusive). The server re-derives the
// caller's own interviewId/ownership and validates the transition — a spoofed `confirmed` is rejected.
//
// `interviewToken` (the `/skillfit-interview/:token` value) selects WHICH of the candidate's
// invitations this is; it is not proof of ownership, which the server re-derives independently from
// the authenticated user (`server/ai-interview/routes/candidateTokenResolver.js`).
// `interviewId` is REQUIRED: the service resolves the session by it before authorizing the caller
// (`screenShareGateService.recordDisclosureEvent` -> `_requireOwnedSession(interviewId, token)`).
// Omitting it made every disclosure report 403 with a body carrying no `message` key, which
// surfaced in the browser as a bare messageless `Error` on the screen-share screen.
export const sendDisclosureEvent = (event, { interviewToken, interviewId } = {}) => dispatch => {
  dispatch({ type: DISCLOSURE_EVENT_REQUEST });
  return submitScreenShareDisclosureEvent({ event, interviewToken, interviewId })
    .then(response => {
      dispatch({ type: DISCLOSURE_EVENT_SUCCESS, payload: response });
      return response;
    })
    .catch(e => {
      dispatch({ type: DISCLOSURE_EVENT_ERROR, error: true, payload: storableError(e) });
      throw e;
    });
};
